import React from 'react';

// Componentns.
import Link from 'components/misc/Link';
import { GitMerge, Info } from 'react-feather';
import { Post } from 'entity/post/postTypes';

const MergedPostCard = (props: { parentPost: Post }) => {
  const { parentPost } = props;
  return (
    <div className="rounded p-4 bg-white h-fit">
      <div className="flex flex-col gap-4 items-center">
        <div className="flex gap-3 items-center">
          <GitMerge className="text-blue-500 m-w-[16px]" size={16} />
          <div className="flex flex-col gap-1">
            <p className="text-xs font-bold">Post Merged</p>
            <p className="text-xs">
              This post is no longer accepting new comments because it has been
              merged with{' '}
              <span className="text-xs text-blue-500">
                <Link
                  href={`/questionDetail?slug=${parentPost.slug}`}
                  as={`/posts/${parentPost.slug}`}
                >
                  <a>{parentPost.title}</a>
                </Link>
              </span>
            </p>
          </div>
        </div>
        <div className="horizontal-divider" />
        <div className="flex items-center gap-3">
          <Info className="text-neutral-400 m-w-[16px]" size={16} />
          <a
            className="text-xs text-neutral-500 hover:text-blue-500"
            target="_blank"
            rel="noopener noreferrer"
            href="https://support.seedly.sg/hc/en-us/articles/900000136506-Questions-Answers-QnA-"
          >
            View our community merged guideline
          </a>
        </div>
      </div>
    </div>
  );
};

export default MergedPostCard;
